/* eslint-disable */
export default {
  noRecords: '최근 레코드를 찾을 수 없습니다.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
